import { ApiMessage } from "../models/api-message.model";

/** @description Parses the JSON error response from the _body.  
 * @param {string} error JSON string.  
 * @return {ApiMessage}  
 */  
export function getErrorMessageFromApiResponse(error): ApiMessage{
    let apiMessage: ApiMessage = null;
    if(error && error._body){
        let parsedMessage = JSON.parse(error._body);
        apiMessage = (<ApiMessage>parsedMessage)
    }
    if(apiMessage === null || typeof apiMessage !== "object"){
        apiMessage = {
            statusCode : error.status,
            messageCode: "1000",
            message: error._body || "Unhandled error",
            messageDetails: null
        };
    }
    return apiMessage;
}

export function isIE(){
    const ua = navigator.userAgent;
    return ua.indexOf("MSIE") > -1 || ua.indexOf("Trident/") > -1;
}

export function formatDateAsLongDate(targetDate) {
    let result: any = null;
    if (targetDate) {
        const date = new Date(targetDate);    
        var options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' };
        result = date.toLocaleDateString("en-US");//, options);
    }    
    return result;
}

export function convertNgbDatePickerObjectToString(obj) {
    const stringDate: string = obj.year + "-" + obj.month + "-" + obj.day;    
    return new Date(stringDate).toISOString().slice(0, 10);
}

export function convertDateToNgbDatePicker(targetDate) {        
    const date = new Date(targetDate);
    const obj = { year: date.getUTCFullYear(), day: date.getUTCDate(), month: date.getUTCMonth() + 1};
    return obj;
}

export function getDateDifferenceInDays(dateObj) {    
    let result: number = null;

    if (dateObj) {
        const targetDate = new Date(dateObj)
        const todaysDate = new Date();
        const todaysUtcDateNumber: number = Date.UTC(todaysDate.getUTCFullYear(), todaysDate.getUTCMonth(), todaysDate.getUTCDate());
        const targetUtcDueDateNumber: number = Date.UTC(targetDate.getUTCFullYear(), targetDate.getUTCMonth(), targetDate.getUTCDate());
        const todaysUtcDate = new Date(todaysUtcDateNumber);
        const targetUtcDueDate = new Date(targetUtcDueDateNumber);    
        const timeDiff = new Date(targetUtcDueDate).getTime() - new Date(todaysUtcDate).getTime();
        result = Math.ceil(timeDiff / (1000 * 3600 * 24));        
    }
    return result;
}

export function getLockStatusDescription(actionNumber) {
    let lockStatus: string = null;
    switch (actionNumber) {
        case 2:
        case 4:
            lockStatus = "Locked";
            break;
        case 1:
        case 3:
            lockStatus = "Unlocked";
            break;
    }
    return lockStatus;
}

export function numberFormatter(labelValue, includeThousandsDecimals=false) {

    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e+9

      ? "$" + Number(Math.abs(Number(labelValue)) / 1.0e+9).toFixed(2) + " B"
      // Six Zeroes for Millions
      : Math.abs(Number(labelValue)) >= 1.0e+6

        ? "$" + Number(Math.abs(Number(labelValue)) / 1.0e+6).toFixed(2) + " M"
        // Three Zeroes for Thousands
        : Math.abs(Number(labelValue)) >= 1.0e+3

          ? "$" + Number(Math.abs(Number(labelValue)) / 1.0e+3).toFixed(includeThousandsDecimals ? 2 : 0) + " K"

          : "$" + Number(Math.abs(Number(labelValue))).toFixed(2);

}